import { values } from 'lodash-es';

import type { LookoRouteObject } from '@/router/LookoRouteObject';

// 업로드 설정 부모 라우터
export const 업로드_설정_부모_라우터 = {
  upload: {
    path: '/settings/upload',
    async lazy() {
      const { default: Page } = await import('@/router/settings/upload/UploadSettingsPage');
      return {
        Component: Page,
      };
    },
    handle: {
      title: '업로드 설정',
      displayInSidebarMenu: true,
    },
  } satisfies LookoRouteObject,
};

// 업로드 설정 > 이미지 설정
export const 이미지_설정_라우터 = {
  'remove-background': {
    path: '/settings/upload/remove-background',
    async lazy() {
      const { default: Page } = await import('@/router/settings/upload/ItemImagePage');
      return {
        Component: Page,
      };
    },
    handle: {
      title: '배경제거 및 여백 설정',
    },
  } satisfies LookoRouteObject,
  'ai-detail': {
    path: '/settings/upload/ai-detail',
    async lazy() {
      const { default: Page } = await import('@/router/settings/upload/AIDetailPage');
      return {
        Component: Page,
      };
    },
    handle: {
      title: '디테일컷 설정',
    },
  } satisfies LookoRouteObject,
  'auto-rotate-image': {
    path: '/settings/upload/auto-rotate-image',
    async lazy() {
      const { default: Page } = await import('@/router/settings/upload/AutoRotateImagePage');
      return {
        Component: Page,
      };
    },
    handle: {
      title: '자동 수평 보정 설정',
    },
  } satisfies LookoRouteObject,

  이미지게시: {
    path: '/settings/upload/image-post',
    async lazy() {
      const { default: Page } = await import('@/router/settings/platform-post/이미지_게시_설정_페이지');
      return {
        Component: () => <Page parents={[업로드_설정_부모_라우터.upload]} />,
      };
    },
    handle: {
      title: '이미지 게시 설정',
    },
  } satisfies LookoRouteObject,
};

// 업로드 설정 > 상품 정보 설정 (필수)
export const 상품_정보_필수_설정_라우터 = {
  'input-field': {
    path: '/settings/upload/input-field',
    async lazy() {
      const { default: Page } = await import('@/router/settings/upload/ItemInputFieldPage');
      return {
        Component: Page,
      };
    },
    handle: {
      title: '상품정보 항목 설정',
    },
  } satisfies LookoRouteObject,
  'item-code': {
    path: '/settings/upload/item-code',
    async lazy() {
      const { default: Page } = await import('@/router/settings/upload/ProductCodePage');
      return {
        Component: Page,
      };
    },
    handle: {
      title: '상품코드 설정',
    },
  } satisfies LookoRouteObject,
  'item-title': {
    path: '/settings/upload/item-title',
    async lazy() {
      const { default: Page } = await import('@/router/settings/upload/ItemTitlePage');
      return {
        Component: Page,
      };
    },
    handle: {
      title: '상품명 설정',
    },
  } satisfies LookoRouteObject,
  price: {
    path: '/settings/upload/price',
    async lazy() {
      const { default: Page } = await import('@/router/settings/upload/PricePage');
      return {
        Component: Page,
      };
    },
    handle: {
      title: '가격 설정',
    },
  } satisfies LookoRouteObject,
  brand: {
    path: '/settings/upload/brand',
    async lazy() {
      const { BrandSettingPage: Page } = await import('@/app/settings/upload/brand/BrandSettingPage');
      return {
        Component: Page,
      };
    },
    handle: {
      title: '브랜드 설정',
    },
  } satisfies LookoRouteObject,
  category: {
    path: '/settings/upload/category',
    async lazy() {
      const { default: Page } = await import('@/router/settings/upload/CategoryPage');
      return {
        Component: Page,
      };
    },
    handle: {
      title: '카테고리 설정',
    },
  } satisfies LookoRouteObject,
  'clothes-size': {
    path: '/settings/upload/clothes-size',
    async lazy() {
      const { default: Page } = await import('@/router/settings/upload/ClothesSizePage');
      return {
        Component: Page,
      };
    },
    handle: {
      title: '치수 설정',
    },
  } satisfies LookoRouteObject,
};

// 업로드 설정 > 상품 정보 설정 (항목 설정에 따라 선택)
export const 상품_정보_선택_설정_라우터 = {
  size: {
    path: '/settings/upload/size',
    async lazy() {
      const { default: Page } = await import('@/router/settings/upload/SizePage/index');
      return {
        Component: Page,
      };
    },
    handle: {
      title: '사이즈 설정',
    },
  } satisfies LookoRouteObject,
  fabric: {
    path: '/settings/upload/fabric',
    async lazy() {
      const { default: Page } = await import('@/router/settings/upload/FabricPage');
      return {
        Component: Page,
      };
    },
    handle: {
      title: '소재 설정',
    },
  } satisfies LookoRouteObject,
  color: {
    path: '/settings/upload/color',
    async lazy() {
      const { default: Page } = await import('@/router/settings/upload/ColorPage');
      return {
        Component: Page,
      };
    },
    handle: {
      title: '색상 설정',
    },
  } satisfies LookoRouteObject,
  condition: {
    path: '/settings/upload/condition',
    async lazy() {
      const { default: Page } = await import('@/router/settings/upload/ConditionPage');
      return {
        Component: Page,
      };
    },
    handle: {
      title: '컨디션 설정',
    },
  } satisfies LookoRouteObject,

  origin: {
    path: '/settings/upload/origin',
    async lazy() {
      const { default: Page } = await import('@/router/settings/upload/OriginPage');
      return {
        Component: Page,
      };
    },
    handle: {
      title: '원산지 설정',
    },
  } satisfies LookoRouteObject,
  'search-keyword': {
    path: '/settings/upload/search-keyword',
    async lazy() {
      const { default: Page } = await import('@/router/settings/upload/SearchKeywordPage');
      return {
        Component: Page,
      };
    },
    handle: {
      title: '검색 키워드 설정',
    },
  } satisfies LookoRouteObject,
  'custom-input-field': {
    path: '/settings/upload/custom-input-field',
    async lazy() {
      const { default: Page } = await import('@/router/settings/upload/CustomInputFieldPage');
      return {
        Component: Page,
      };
    },
    handle: {
      title: '자유 입력란 설정',
    },
  } satisfies LookoRouteObject,
};

// 업로드 설정 > 공급사 설정
export const 공급사_설정_라우터 = {
  supplier: {
    path: '/settings/upload/supplier',
    async lazy() {
      const { default: Page } = await import('@/router/settings/upload/SupplierPage');
      return {
        Component: Page,
      };
    },
    handle: {
      title: '공급사 ・ 묶음배송 설정',
    },
  } satisfies LookoRouteObject,
};

export const 카테고리_설정_라우터 = {
  상세_분류_편집: {
    path: '/settings/upload/category/edit-properties',
    async lazy() {
      const { default: Page } = await import('@/router/settings/upload/상세_분류_편집_페이지');
      return {
        Component: Page,
      };
    },
    handle: {
      title: '상세 분류 편집',
    },
  } satisfies LookoRouteObject,
  상품군_추가: {
    path: '/settings/upload/category/create-mapping-group',
    async lazy() {
      const { default: Page } = await import('@/router/settings/upload/상품군_추가_페이지');
      return {
        Component: Page,
      };
    },
    handle: {
      title: '상품군 추가',
    },
  } satisfies LookoRouteObject,
};

// 업로드 설정
const 업로드_설정_라우터: LookoRouteObject[] = [
  ...values(업로드_설정_부모_라우터),
  ...values(상품_정보_필수_설정_라우터),
  ...values(상품_정보_선택_설정_라우터),
  ...values(이미지_설정_라우터),
  ...values(공급사_설정_라우터),
  ...values(카테고리_설정_라우터),
];

export default 업로드_설정_라우터;
